import { render } from "./AddonEvents.vue?vue&type=template&id=398b64cd&scoped=true"
import script from "./AddonEvents.vue?vue&type=script&lang=js"
export * from "./AddonEvents.vue?vue&type=script&lang=js"

import "./AddonEvents.vue?vue&type=style&index=0&id=398b64cd&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398b64cd"]])

export default __exports__